export const getMSFromSeconds = (seconds: number) => seconds * 1000;
export const getMSFromMinutes = (minutes: number) =>
	getMSFromSeconds(minutes * 60);
export const getMSFromHours = (hours: number) => getMSFromMinutes(hours * 60);
export const getMSFromDays = (hours: number) => getMSFromHours(hours * 24);
